import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Storage } from '@ionic/storage';
import { forkJoin } from 'rxjs/observable/forkJoin';
import { environment } from '../../environments/environment';

@Injectable()
export class ConfigProvider {
  instituicao: any;
  usuario: any;
  config: any;
  baseUrl = environment.API_URL;
  constructor(
    public http: HttpClient,
    private storage: Storage,
  ) {
    forkJoin(this.storage.get('instituicao'), this.storage.get('user'), this.storage.get('config')).subscribe(
      ([instituicao, user, config]) => {
        this.instituicao = instituicao;
        this.usuario = user;
        this.config = config;
      },
    );
  }

  async validarInit() {
    if (!this.instituicao || !this.usuario || !this.config) await this.setData();
  }

  async setData() {
    this.instituicao = await this.storage.get('instituicao').then((data) => {
      return data;
    });

    this.usuario = await this.storage.get('user').then((data) => {
      return data;
    });

    this.config = await this.storage.get('config').then((data) => {
      return data;
    });
  }

  async getNomenclatura(n) {
    await this.validarInit();
    if (n && this.instituicao && this.instituicao.nomenclatura[n.toLowerCase()]) {
      return this.instituicao.nomenclatura[n.toLowerCase()];
    }
    return n;
  }

  async getCurrencySymbol() {
    await this.validarInit();
    return {
      currency: this.config.currencySymbol,
      currencyDecimal: this.config.currencyDecimal,
      currencyThousands: this.config.currencyThousands,
    };
  }

  async hasConfiguracao(config) {
    await this.validarInit();
    if (!config || !this.instituicao) return false;

    return this.instituicao.configPortalAplicativo[config] ? true : false;
  }

  async getConfiguracao() {
    await this.validarInit();
    return this.instituicao.configPortalAplicativo;
  }

  async getMaskTelApp() {
    await this.validarInit();
    return this.config.maskTelApp;
  }

  async hasPermissao(perm) {
    await this.validarInit();
    if (!perm || !this.usuario) return false;

    return this.usuario.perm[perm] ? true : false;
  }

  async getPermissao() {
    await this.validarInit();
    return this.usuario.perm;
  }

  async hasMenu(menu) {
    await this.validarInit();

    if (!menu || !this.usuario) return false;

    return this.usuario.menu[menu];
  }

  async getInstituicao() {
    await this.validarInit();
    return this.instituicao;
  }

  async getUsuario() {
    await this.validarInit();
    return this.usuario;
  }

  async getConfig() {
    await this.validarInit();
    return this.config;
  }

  setConfiguracao(id, status) {
    return this.http.post<any>(this.baseUrl + '/configuracao', { id: id, status: status }).map((data) => {
      if (!data.error) {
        return data;
      } else {
        return false;
      }
    });
  }

  getConfiguracoes() {
    return this.http.get<any>(this.baseUrl + '/configuracao').map((data) => {
      if (!data.error) {
        return data;
      } else {
        return false;
      }
    });
  }

  getDateFormat() {
    if (this.config && this.config.masks && this.config.masks.DATA && this.config.masks.DATA.mask) {
      return this.config.masks.DATA.mask;
    } else {
      return 'DD/MM/YYYY';
    }
  }
}



// WEBPACK FOOTER //
// ./src/providers/config/config.ts